import 'isomorphic-fetch';
import { push } from 'react-router-redux';

import { receiveGlobalMeta, getCacheBuster } from 'Actions/MetaActions';
import { getLoadingBehavior, fetchSuccess } from 'Actions/InfiniteScrollActions';
import { setLastGlobalAction, setGlobalNotification, backInHistory, getFetchConfig } from 'Actions/GlobalMetaActions';
import { responseNormalizer, updateUstate } from 'Actions/responseNormalizer';

export const PORTALPAGE_FETCH = 'PORTALPAGE_FETCH';
export const PORTALPAGE_SUCCESS = 'PORTALPAGE_SUCCESS';
export const PORTALPAGE_FAILURE = 'PORTALPAGE_FAILURE';
export const PORTALPAGE_RESET = 'PORTALPAGE_RESET';

export function requestPortalPage( page ) {
	return {
		type: PORTALPAGE_FETCH,
		page: page
	};
}

export function receivePortalPage( page, data ) {
	return {
		type: PORTALPAGE_SUCCESS,
		page: page,
		data: data
	};
}

export function failedPortalPage( page, error ) {
	return {
		type: PORTALPAGE_FAILURE,
		page: page,
		error: error
	};
}

export function resetPortalPage() {
	return {
		type: PORTALPAGE_RESET
	}
}

export function fetchPortalPage( pageRequest, cacheBust = false ) {

	return function( dispatch, getState ) {
		pageRequest.loadingBehavior = getLoadingBehavior( getState, pageRequest.pagename, "portalpage", 1, true );

		dispatch( requestPortalPage( pageRequest ) );

		const state = getState();
		const url = state.topifyPresets.forumSite.url;

		// Avoid Cache if cacheBust is required
		let fetchConfig = dispatch( getFetchConfig( cacheBust ) ),
			cacheBustQueryString = '&_=' + ( cacheBust ? cacheBust : ( getCacheBuster( getState ) || 0 ) );

		return fetch( url + `?v=3.0&ajax=1&uid=0&req=portal&pagename=${pageRequest.pagename}${ cacheBustQueryString }`, fetchConfig ).then( ( response ) => {
				if( !response.ok ) {
					setGlobalNotification( dispatch, {}, response );

					dispatch( failedPortalPage( pageRequest, 'Bad response from server' ) );
					dispatch( backInHistory() );

				} else {
					response.json().then( ( json ) => {
							setGlobalNotification( dispatch, json, { ok: true } );

							let other = Object.assign( {}, json.portal ? json.portal.meta : {} );

							let result = responseNormalizer( json, false, other );

							const forumTitle = state.topifyPresets.forumSite.f_title;

							if( json.portal ) {
								dispatch( receiveGlobalMeta( json.portal.meta, json.portal.meta.title, forumTitle ) );
							} else {
								dispatch( receiveGlobalMeta( null, forumTitle ) );
							}

							dispatch( updateUstate( json, result ) );

							dispatch( fetchSuccess( pageRequest.pagename, "portalpage", 1, 1, pageRequest.loadingBehavior ) );
							dispatch( receivePortalPage( pageRequest, result ) );
						}
					)
				}
			}
		).then( ()=> {
			setLastGlobalAction( 'portalpage', pageRequest );

		} ).catch( ( error ) => {
			setGlobalNotification( dispatch, {}, error );
			dispatch( failedPortalPage( pageRequest, 'Bad response from server' ) );
			dispatch( backInHistory() );
		} );
	}
}



// WEBPACK FOOTER //
// ./src/actions/PortalPageActions.js